import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import './MembershipStages.css';

const MembershipStages = () => {
  const stages = [
    {
      num: '01',
      badge: 'PRE-SEED',
      title: 'Launch',
      desc: 'Validate, build momentum and connect with early supporters.'
    },
    {
      num: '02',
      badge: 'SEED–SERIES A',
      title: 'Growth',
      desc: 'Turn product-market fit into repeatable revenue and capital.'
    },
    {
      num: '03',
      badge: 'SERIES B+',
      title: 'Scale',
      desc: 'Expand reach, strengthen leadership and enter new markets.'
    },
    {
      num: '04',
      badge: 'SCALED & EXITED',
      title: 'Leaders Council',
      desc: 'Exchange insight with accomplished founders and ecosystem leaders.'
    }
  ];

  return (
    <div className="ms-container">
      <Grid container className="ms-main-grid" alignItems="stretch">
        {/* Left Hero Column */}
        <Grid item xs={12} md={5} className="ms-left-col">
          <div className="ms-sticky-content">
            <div>
              <Typography className="ms-subheading">MEMBERSHIP</Typography>
              <Typography className="ms-heading-main">
                The right room<br />at every stage.
              </Typography>
            </div>
            <div>
              <a href="#membership" className="ms-view-link">
                VIEW MEMBERSHIP <span className="ms-view-arrow">↗</span>
              </a>
            </div>
          </div>
        </Grid>

        {/* Right Cards Grid */}
        <Grid item xs={12} md={7} className="ms-right-col">
          <Grid container className="ms-grid-container">
            {stages.map((stage, index) => (
              <Grid item xs={12} sm={6} key={index} className="ms-grid-item">
                <div className="ms-card">
                  <Typography className="ms-card-num">{stage.num}</Typography>
                  <div className="ms-badge-wrapper">
                    <span className="ms-badge">{stage.badge}</span>
                  </div>
                  <Typography className="ms-card-title">{stage.title}</Typography>
                  <Typography className="ms-card-desc">{stage.desc}</Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default MembershipStages;